export default __webpack_public_path__ + "static/media/hablogintegration.0c0bcacc.mov";